export const GROUP_API = '/api/group/'
export const GROUPTYPE_API = '/api/grouptype/'
export const PRODUCT_API = '/api/product/'
export const GROUP_PARENTS_API = '/api/group/parents/'
export const REGION_API = '/api/region/'
export const REGION_ACTION_API = '/api/region/apply-action/'
export const SCOPES_API = '/api/scopes/'
export const PARAMETER_API = '/api/parameter/'
export const PRICETYPE_API = '/api/pricetype/'
export const TABLETYPE_API = '/api/tabletype/'
export const TABLE_API = '/api/table/'
export const GROUP_CHILDREN_API = '/api/group/children/'
export const PRODUCT_STATUS_API = '/api/product-status/'
export const PROVIDER_API = '/api/provider/'
export const CONCURRENT_API = '/api/concurrent/'
export const CONCURRENT_REGION_API = '/api/concurrent-region/'
export const CONCURRENT_PRICE_TYPE_API = '/api/concurrent-pricetype/'
export const CONCURRENT_PRODUCT_STATUS_API = '/api/concurrent-product-status/'
export const SETTING_API = '/api/setting/'
export const PROVIDER_DATA_API = '/api/provider-data'
export const FUNCTION_API = '/api/functions/'
export const VALUE_PARAMETER_API = '/api/value-parameter/'
export const VALUE_PARAMETER_UPDATE_API = '/api/value-parameter/update'
export const VALUE_PARAMETER_CREATE_API = '/api/value-parameter/create'
export const OBJECT_TYPE_API = '/api/object-types/'
export const POLITIC_API = '/api/politic/'
export const FUNCTION_EXECUTE_API = '/api/function/execute'
export const REPRICING_OPTION_API = '/api/repricing-option/'
export const POLITIC_EXECUTE_API = '/api/politic-test-execute'
export const PRICE_LEVEL_API = '/api/price-levels/'
export const PRICE_LEVEL_CALC_FUNC_API = '/api/price-level-calc-func/'
export const PRICE_LEVEL_EXECUTE = '/api/price-level-exec/'
export const PRICE_LEVEL_IS_EXECUTE = '/api/price-level-is-exec/'
export const REGION_GROUP_API = '/api/region-groups/'
export const PRICETYPE_GROUP_API = '/api/pricetype-groups/'
export const PRICE_LEVEL_RESULT_API = '/api/price-level-results/'
export const TEST_PRICE_LEVEL_RESULT_API = '/api/price-level-test-results/'
export const TEST_PRICE_LEVEL_EXECUTE_API = '/api/price-level-test-exec/'
export const PRIOR_REPRICING_API = '/api/prior-repricing/'
export const TEST_POLITIC_RESULTS_API = '/api/test-politic-results/'
export const REPRICING_LAST_TASK_API = '/api/repricing-last-user-task/'
export const REPRICING_PRICE_LEVEL_API = '/api/repricing-price-levels/'
export const REPRICING_TASK_QUEUE_API = '/api/repricing-task-queue/'
export const REPRICING_TASK_CANCEL_API = '/api/repricing-task-cancel/'
export const REPRICING_TASK_DELETE_API = '/api/repricing-task-delete/'
export const REPRICING_PRICES_API = '/api/repricing-prices/'
export const REPRICING_LOGS_API = '/api/repricing-logs/'
export const REPRICING_LAST_SUCCESS_TASK_API = '/api/repricing-last-success-task/'
export const PRODUCT_ALLOCATION_RULE_API = '/api/product-allocation-rule/'
export const PRODUCT_NOT_ALLOCATION_API = '/api/product-not-allocation/'
export const PRODUCT_POSTPONE_API = '/api/product-postpone/'
export const PRODUCT_ALLOCATION_ONE_API = '/api/product-allocation-one/'
export const PRODUCT_POSTPONE_ONE_API = '/api/product-postpone-one/'
export const PRODUCT_POSTPONE_REM_API = '/api/product-postpone-rem/'
export const POLITIC_COPY_API = '/api/politic-copy/'
export const USER_LIST_API = '/api/users-list/'
export const STOCK_API = '/api/stock/'
export const STOCK_BALANCE_API = '/api/stock-balance/'
export const SUPPLIER_API = '/api/supplier/'
export const SUPPLIER_BALANCE_API = '/api/supplier-balance/'
export const STOCK_LEVEL_API = '/api/stock-level/'
export const STOCK_LEVEL_CALC_FUNC_API = '/api/stock-level-calc-func/'
export const REPRICING_STOCK_LEVEL_API = '/api/repricing-stock-levels/'
export const CATALOG_API = '/api/catalog-items/'
export const GROUP_PATH_API = '/api/group/path/'
export const REPRICING_SCHEDULE_API = '/api/repricing-schedule/'
export const TABLE_COPY_API = '/api/table-copy/'
export const PRICE_API = '/api/price/'
export const PRICE_LEVEL_COPY_API = '/api/price-level-copy/'
export const MONITORING_SCHEDULE_API = '/api/monitoring-schedule/'
export const FIX_PRICES_API = '/api/fix-prices/'
export const SEARCH_PRODUCT_BY_CODE_API = '/api/product/search-by-code/'
export const FIX_PRICES_COPY_API = '/api/fix-prices/copy/'
export const FIX_PRICES_ITEMS_API = '/api/fix-prices-prices/'
export const FIX_PRICES_ITEM_UPDATE_API = '/api/fix-prices-item-price/'
export const SCHEDULE_API = '/api/schedule/'
export const PARAMETER_HAS_VALUES_API = '/api/parameter-has-values/'
export const UPDATE_UNALLOCATED_API = '/api/unallocated/'
export const FIX_PRICES_ITEM_INTERSECTION_API = '/api/fix-prices-item-intersection/'
export const EVENT_PER_DAY_API = '/api/events-per-day/'
export const EVENT_PER_HOUR_API = '/api/events-per-hour/'
export const EVENT_PAGES_API = '/api/events-pages/'
export const EVENT_REGIONS_API = '/api/events-regions/'
export const MONITORING_COVERAGE_API = '/api/monitoring-coverage/'
export const CORRECTIONS_API = '/api/corrections/'
export const CORRECTION_PARAM_API = '/api/correction-param/'
export const CORRECTION_PRICE_API = '/api/correction-price/'
export const CORRECTION_PRICE_ITEMS_API = '/api/correction-price-items-add/'
export const CORRECTION_ON_DATE_API = '/api/correction-on-date/'
export const CORRECTION_COPY_API = '/api/correction-copy/'
export const CORRECTION_PRICE_ITEMS_EXISTS = '/api/correction-prices-exists'
export const CORRECTION_PRICE_ITEM_EXISTS = '/api/correction-price-exists'
export const RUN_SCHEDULE_ACTION = '/api/run-schedule/'
export const CLIENTS_API = '/api/clients/'
export const CARD_TYPES_API = '/api/card-types/'
export const LOYALTY_EVENT_TYPES_API = '/api/loyalty-event-types/'
export const CARD_OBJECT_TYPES_API = '/api/card-object-types/'
export const CARD_PARAMETER_API = '/api/card-parameters/'
export const CARDS_API = '/api/cards/'
export const CARD_VALUE_PARAMETER_API = '/api/card-value-parameter/'
export const LOYALTY_POLITICS_API = '/api/loyalty-politics/'
export const LOYALTY_EVENTS_API = '/api/loyalty-events/'
export const LOYALTY_RULES_API = '/api/loyalty-rules/'
export const LOYALTY_LOG_API = '/api/loyalty-log/'
export const CARD_VALUE_PARAMETER_UPDATE_API = '/api/card-value-parameter/update'
export const CARD_VALUE_PARAMETER_CREATE_API = '/api/card-value-parameter/create'
export const LOYALTY_POLITIC_TEST_API = '/api/loyalty-politic-test'
export const SEND_PRICES_TO_EXCHANGE_API = '/api/send-priced-to-exchange'
export const TEAM_CHAT_MESSAGE_API = '/api/team-chat/message'
export const TEAM_CHAT_API = '/api/team-chat/chat'
export const TASK_API = '/api/tasks/'
export const TASK_DONE_API = '/api/task-done/'
export const USER_TASK_API = '/api/user-tasks/'
export const ALL_TASK_API =  '/api/all-tasks/'
export const SALES_CHANNEL_API = '/api/sales-channel/'
export const PROMO_CODE_API = '/api/promo-code/'
export const BADGE_API = '/api/badge/'
export const MARKETING_EVENT_TYPES_API = '/api/marketing-event-types/'
export const RULE_PRIORITY_API = '/api/rule-priority/'
export const SHOP_API = '/api/shop/'
export const SHOWCASE_TYPE_API = '/api/showcase-type/'
export const SHOWCASE_API = '/api/showcase/'
export const SHOWCASE_MODULE_TYPE_API = '/api/showcase-module-type/'
export const SHOWCASE_TEMPLATE_API = '/api/showcase-template/'
export const SHOWCASE_MODULE_API ='/api/showcase-module/'
export const MARKETING_RULE_API ='/api/marketing-rules/'
export const MARKETING_POLITIC_API ='/api/marketing-politics/'
export const PRODUCT_PROPERTIES_API = '/api/product-properties/'
export const PRODUCT_PRICE_API = '/api/product-price/'
export const MARKETING_OBJECT_TYPES_API = '/api/marketing-object-types/'
export const MARKETING_PARAMETER_API = '/api/marketing-parameters/'
export const CONSTELLATION_API = '/api/constellation/'
export const MARKETING_VALUE_PARAMETER_API = '/api/marketing-value-parameter/'
export const MARKETING_VALUE_PARAMETER_UPDATE_API = '/api/marketing-value-parameter/update'
export const MARKETING_VALUE_PARAMETER_CREATE_API = '/api/marketing-value-parameter/create'
export const MARKETING_CONDITION_API ='/api/marketing-conditions/'
export const COMMERCIAL_PARAMETER_API = '/api/commercial-parameters/'
export const COMMERCIAL_PRIORITY_API = '/api/commercial-priorities/'
export const COMMERCIAL_PRIORITY_VALUE_API = '/api/commercial-priority-value/'
export const COMMERCIAL_RULE_API = '/api/commercial-rules/'
export const COMMERCIAL_RULE_PRODUCT_FILTER_API = '/api/commercial-rules-products/'
export const MARKETING_EVENT_API = '/api/marketing-events/'
export const MARKETING_POLITIC_TEST_API = '/api/marketing-politic-test'
export const MARKETING_TRIGGER_API = '/api/marketing-triggers/'
export const MARKETING_EVENT_TYPE_DATA_API = '/api/marketing-event-type-data/'
export const MARKETING_PARAMS_HISTORY = '/api/marketing-params-history/'
